var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.502 29.9791C11.502 32.0402 13.227 33.7265 15.3353 33.7265C17.4436 33.7265 19.1686 32.0402 19.1686 29.9791V22.4844H26.8353C28.9436 22.4844 30.6686 20.798 30.6686 18.737C30.6686 16.6759 28.9436 14.9896 26.8353 14.9896H19.1686V7.49482C19.1686 5.43376 17.4436 3.74744 15.3353 3.74744C13.227 3.74744 11.502 5.43376 11.502 7.49482V14.9896H3.83529C1.72695 14.9896 0.00195312 16.6759 0.00195312 18.737C0.00195312 20.798 1.72695 22.4844 3.83529 22.4844H11.502V29.9791Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.834,
    cy: 52.4633,
    rx: 11.5,
    ry: 11.2421,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3483 22.4844H80.5C84.7167 22.4844 88.1667 25.857 88.1667 29.9792V74.9478C88.1667 79.0699 84.7167 82.4425 80.5 82.4425H19.1667C14.95 82.4425 11.5 79.0699 11.5 74.9478V36.4247C12.65 37.0617 13.915 37.4739 15.3333 37.4739C19.55 37.4739 23 34.1013 23 29.9792V26.2318H26.8333C31.05 26.2318 34.5 22.8591 34.5 18.737C34.5 17.3505 34.0783 16.1138 33.4267 14.9896H57.96C60.1067 14.9896 62.1767 15.889 63.595 17.4254L68.3483 22.4844ZM30.6699 52.4634C30.6699 62.8061 39.2565 71.2003 49.8366 71.2003C60.4166 71.2003 69.0032 62.8061 69.0032 52.4634C69.0032 42.1206 60.4166 33.7264 49.8366 33.7264C39.2565 33.7264 30.6699 42.1206 30.6699 52.4634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.35df48c45aa3057969b71a67657b142e.svg";
export { ForwardRef as ReactComponent };